import axios from 'axios';
import * as types from './actionTypes';
import { handleError } from '../errors/handleError';
import { getFmsClientId } from '../apis/FmsIdApi';

export function errorHandler(dispatch, error, type) {
    const errorMessage = handleError(error, true);

    dispatch({
        type,
        error: errorMessage,
    });
}

export function getForms(type) {
    return function (dispatch) {
        dispatch({
            type: types.GET_FORMS_PENDING,
        });
        return axios.get(`${window.GENESIS_CMS_API_URL}/v3/forms?queryType=${type}&token=${window.genesisToken()}&sessionid=${localStorage.getItem('SessionId')}`)
            .then((response) => {
                dispatch({
                    type: types.GET_FORMS_SUCCESS,
                    payload: response.data.data,
                });
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.GET_FORMS_FAILED);
            });
    };
}

export function getCurrentFmsId() {
    return getFmsClientId()
        .then((response) => {
            localStorage.setItem('FmsId', response.data.data);
        })
        .catch(() => {
        });
}
